import request from '@/utils/request'

/**
 * 咨询-文章管理-文章列表
 * @param {string} token
 */
export function dataList(params) {
  return request({
    url: '/api/v1/article/dataList',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-是否推荐
 * @param {string} token
 * @param {string} articleId 文章id
 */
export function isRecommendArticle(params) {
  return request({
    url: '/api/v1/article/isRecommendArticle',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-文章状态启用/禁用
 * @param {string} token
 * @param {string} articleId 文章id
 */
export function isStateArticle(params) {
  return request({
    url: '/api/v1/article/isStateArticle',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-文章排序
 * @param {string} token
 * @param {string} articleId 文章id
 * @param {string} seqIndex 排序号
 */
export function sortSeqIndex(params) {
  return request({
    url: '/api/v1/article/sortSeqIndex',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-删除文章
 * @param {string} token
 * @param {string} articleId 文章id
 */
export function delArticle(params) {
  return request({
    url: '/api/v1/article/delArticle',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-查询下拉可用分类列表
 * @param {string} token
 */
export function columnList(params) {
  return request({
    url: '/api/v1/article/columnList',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-科室类型的时候返回科室列表
 * @param {string} token
 */
export function deptList(params) {
  return request({
    url: '/api/v1/article/deptList',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-新增文章
 * @param {string} token
 * @param {string} articleId  文章ID，编辑时可用
 * @param {string} columnId   所属分类ID
 * @param {string} content    文章内容
 * @param {string} orgId      来源（医院或科室ID，属性对应的机构ID）
 * @param {boolean} state     当前状态，true启用，false禁用
 * @param {string} title      文章标题
 * @param {integer} type      属性类型，0医院，1科室
 */
export function addArticle(data) {
  return request({
    url: '/api/v1/article/addArticle',
    method: 'post',
    data,
  })
}

/**
 * 咨询-文章管理-文章详情
 * @param {string} token
 * @param {string} articleId  文章ID，编辑时可用
 */
export function articleDetail(params) {
  return request({
    url: '/api/v1/article/articleDetail',
    method: 'get',
    params,
  })
}

/**
 * 咨询-文章管理-编辑文章
 * @param {string} token
 * @param {string} articleId  文章ID，编辑时可用
 * @param {string} columnId   所属分类ID
 * @param {string} content    文章内容
 * @param {string} orgId      来源（医院或科室ID，属性对应的机构ID）
 * @param {boolean} state     当前状态，true启用，false禁用
 * @param {string} title      文章标题
 * @param {integer} type      属性类型，0医院，1科室
 */
export function editArticle(data) {
  return request({
    url: '/api/v1/article/editArticle',
    method: 'post',
    data,
  })
}

/**
 * 咨询-文章管理-批量删除文章
 * @param {string} token
 * @param {array} articles  文章ID集合
 */
export function batchDelArticle(data) {
  return request({
    url: '/api/v1/article/batchDelArticle',
    method: 'post',
    data,
  })
}

/**
 * 咨询-文章管理-批量推荐
 * @param {string} token
 * @param {array} articles  文章ID集合
 */
export function batchRecommendArticle(data) {
  return request({
    url: '/api/v1/article/batchRecommendArticle',
    method: 'post',
    data,
  })
}

/**
 * 咨询-文章管理-批量取消推荐
 * @param {string} token
 * @param {array} articles  文章ID集合
 */
export function batchCancelRecommendArticle(data) {
  return request({
    url: '/api/v1/article/batchCancelRecommendArticle',
    method: 'post',
    data,
  })
}
